// IT
export const ASSOCIATE_BUSINESS_SYSTEM_ANALYST = "BIT300";
export const ASSOCIATE_APPLICATION_DEVELOPER = "BIT306";
export const ASSOCIATE_RELIABILITY_ENGINEER = "BIT307";
export const BUSINESS_SYSTEM_ANALYST = "BIT350";
export const APPLICATION_DEVELOPER = "BIT354";
export const RELIABILITY_ENGINEER = "BIT357";
export const SENIOR_BUSINESS_SYSTEM_ANALYST = "BIT400";
export const SENIOR_APPLICATION_DEVELOPER = "BIT406";
export const LEAD_APPLICATION_DEVELOPER = "BIT452";
export const IT_BUSINESS_PARTNER = "BIT500";
export const MANAGER_I_RELIABILITY_ENGINEER = "BIT654";

// HR
export const ASSOCIATE_TALENT_DEVELOPMENT_PARTNER = "BHR301";
export const SENIOR_HRIS_ANALYST = "BHR401";

// Quality
export const QUALITY_SPECIALIST = "BQU100";
export const QUALITY_DATA_ANALYST = "BQU350";
export const QUALITY_SYSTEMS_ANALYST = "BQU351";
export const SENIOR_QUALITY_SYSTEMS_ANALYST = "BQU400";
export const QUALITY_CONTROL_MANAGER = "BQU450";
export const MANAGER_I_QUALITY = "BQU650";
export const DIRECTOR_QUALITY = "BQU800";

// Field Management
export const FOREMAN_CRANE = "BFM200";
export const FOREMAN_ELECTRICAL = "BFM201";
export const FOREMAN_GRADING = "BFM202";
export const FOREMAN_LABORER = "BFM203";
export const FOREMAN_MAINTENANCE_NONWORKING = "BFM205";
export const FOREMAN_MAINTENANCE_CDL = "BFM206";
export const FOREMAN_STRUCTURES_CONCRETE = "BFM207";
export const FOREMAN_COMMISSIONING = "BFM208";
export const FOREMAN_INSTALLATION = "BFM209";
export const FOREMAN_SURVEYOR = "BFM211";
export const FIELD_ENGINEER = "BFM352";
export const QUALITY_SUPERINTENDENT = "BFM600";
export const QUALITY_SUPERINTENDENT_II = "BFM601";
export const PROJECT_ENGINEER = "BFM602";
export const PROJECT_CONSTRUCTION_COORDINATOR = "BFM603";
export const ASSISTANT_ELECTRICAL_SUPERINTENDENT = "BFM652";
export const ELECTRICAL_SUPERINTENDENT = "BFM653";
export const ASSISTANT_GRADING_SUPERINTENDENT = "BFM654";
export const GRADING_SUPERINTENDENT = "BFM655";
export const ASSISTANT_INSTALLATION_SUPERINTENDENT = "BFM657";
export const INSTALLATION_SUPERINTENDENT = "BFM658";
export const ASSISTANT_STRUCTURES_SUPERINTENDENT = "BFM663";
export const STRUCTURES_SUPERINTENDENT = "BFM664";
export const SITE_MANAGER = "BFM700";

// Operations
export const COMMISSIONING_SUPERINTENDENT = "BOP651";
export const GENERAL_SUPERINTENDENT = "BOP750";
export const PROJECT_MANAGER = "BOP751";
export const PROJECT_MANAGER_II = "BOP752";
export const SENIOR_PROJECT_MANAGER = "BOP753";
export const DIRECTOR_FIELD_OPERATIONS = "BOP803";

// Safety
export const FLEET_SAFETY_SPECIALIST_COMPLIANCE = "BSC100";
export const FLEET_SAFETY_SPECIALIST_DOT = "BSC101";

// Field Services
export const SITE_INVENTORY_SPECIALIST = "BFS107";
export const SENIOR_SITE_INVENTORY_SPECIALIST = "BFS108";

// Process Improvement
export const FIELD_PROCESS_IMPROVEMENT_SPECIALIST = "BTO100";
export const ASSOCIATE_FIELD_PROCESS_IMPROVEMENT_ANALYST = "BTO301";
export const FIELD_PROCESS_IMPROVEMENT_ANALYST = "BTO353";
export const SENIOR_FIELD_PROCESS_IMPROVEMENT_ANALYST = "BTO402";
export const MANAGER_I_FIELD_PROCESS_IMPROVEMENT = "BTO652";
export const SENIOR_MANAGER_PROCESS_IMPROVEMENT = "BTO751";

// Standard Work Trainer
/** Job codes eligible to receive Standard Work Trainer certifications: Foreman (BFM200–BFM211) and Field Engineer (BFM352). */
export const SWT_ELIGIBLE_JOB_CODES: string[] = [
    FOREMAN_CRANE,
    FOREMAN_ELECTRICAL,
    FOREMAN_GRADING,
    FOREMAN_LABORER,
    FOREMAN_MAINTENANCE_NONWORKING,
    FOREMAN_MAINTENANCE_CDL,
    FOREMAN_STRUCTURES_CONCRETE,
    FOREMAN_COMMISSIONING,
    FOREMAN_INSTALLATION,
    FOREMAN_SURVEYOR,
    FIELD_ENGINEER,
];
